import type { DynamicFieldFormula, LinkedIssuesFormula } from '../types.tsx';
import { LINKED_ISSUES_TEMPLATE } from './types.tsx';

export const isLinkedIssuesFormula = (
	formula: DynamicFieldFormula,
): formula is LinkedIssuesFormula => formula.template === LINKED_ISSUES_TEMPLATE;
